import React, { useContext } from 'react'
import { Row, Col } from 'antd';
import { ApplicationContext, EViewPort } from 'App/context'
import UserMenu from '../../../../common/layouts/App/TopBar/UserMenu'
import HeaderActions from '../../../components/headeractions'

const TopBar = () => {
  const ctx = useContext(ApplicationContext)

  return (
    <Row align="middle" justify="end" gutter={[16, 16]}>
      <Col className="TriggerAndLogo" lg={16} md={10} xs={8}>
        <HeaderActions />
      </Col>
      <Col lg={8} md={14} xs={16} style={{ textAlign: 'end' }} className="userOptions">
        <UserMenu />
      </Col>
    </Row>
  )
}

export default TopBar
